// extracted by mini-css-extract-plugin
module.exports = {"spotListItem":"SpotListItem_spotListItem__aJkW1"};